import type {
  MappedNotificationCounts,
  NotificationSummaryModel,
} from "../types";

export {
  UPDATES_SCREEN_LABEL,
  askScopeLabel,
  askSurfaceCaption,
  buildAskEmptySuggestions,
  buildUpdatesAskUiContext,
  toSolCategoryKey,
} from "./askUiContext";
export type { AskEmptySuggestion, UpdatesAskOrigin } from "./askUiContext";

export {
  boardAlertDescription,
  emphasizePhrase,
  fileDescription,
  generalDescription,
  isStatusCategoryNotification,
  italicizePhrase,
  leadsDescription,
  noteDescription,
  nudgeDescription,
  pickTrimmed,
  reminderDescription,
  resolveBoardLabel,
  scheduleDescription,
  statusDescription,
} from "./descriptions";

/** Summary mosaic only needs total + notable counts. */
export function buildNotificationSummary(
  mapped: MappedNotificationCounts,
): NotificationSummaryModel {
  return {
    total: mapped.total,
    notable: mapped.notable,
  };
}
